import { render, staticRenderFns } from "./render-page-steps.vue?vue&type=template&id=8338edc6"
import script from "./render-page-steps.vue?vue&type=script&lang=js"
export * from "./render-page-steps.vue?vue&type=script&lang=js"
import style0 from "./render-page-steps.vue?vue&type=style&index=0&id=8338edc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports